import { auth } from 'library/firebase/firebase';

const ROOMS_URL = 'https://rooms.zezamii.com';

/**
 * Opens the Rooms Dashboard in a new tab, passing the current user's
 * Firebase ID token so Rooms can establish its own auth session.
 *
 * Usage:  openRooms()              → opens Rooms at its default route
 *         openRooms('/dashboard/rooms')  → opens a specific page
 */
const openRooms = async (path = '/') => {
	const user = auth.currentUser;
	if (!user) {
		throw new Error('No authenticated user — cannot open Rooms.');
	}

	const idToken = await user.getIdToken();
	const url = new URL(path, ROOMS_URL);
	url.searchParams.set('token', idToken);
	window.open(url.toString(), '_blank');
};

export default openRooms;
